exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/markl/projects/angularapp/src/app/components/post/post.component.css
// module id = ../../../../../src/app/components/post/post.component.css
// module chunks = main